import {Box, Button, Card, Modal, CircularProgress} from "@mui/material";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import "./style.scss";
import {getSumsubStatusReq, getSumsubTokenRequest} from "../../../utils/apis/user";
import SumsubWebSdk from "@sumsub/websdk-react";
import {returnErrors} from "../../../store/reducers/error";

const SumsubModal = ({open, sumHandleClose, kycStatus, getSumsubStatus, setOpen}) => {
  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(true);
  const {idToken} = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const getAccessToken = async () => {
    setLoading(true);
    try {
      const response = await getSumsubTokenRequest(idToken);
      if (response?.response?.status > 399) {
        setOpen(false);
        dispatch(returnErrors(response?.response?.data?.detail || "Something went wrong", 400));
      }
      setAccessToken(response.data.token);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getAccessToken();
    }
    getSumsubStatus();
  }, [open]);

  const accessTokenExpirationHandler = (args) => {
    getAccessToken();
    getSumsubStatus();
  };
  const messageHandler = (message) => {
    // dispatch(getSumsubApplicantStatus()).then((res) => {
    //   dispatch(getPayoutVerificationStatus());
    // });

    if (message === "idCheck.applicantReviewComplete") {
      // KYC Approved
    }
  };

  const errorHandler = (args) => {};

  return (
    <Modal
      open={open}
      onClose={sumHandleClose}
      className="Modal"
    >
      <Box
        className="Modal-parent"
        gap={1}
        width={{xs: "80%", md: "40%"}}
        margin="auto"
        marginTop="10%"
      >
        <Card
          className="Modal-card"
          variant="outlined"
        >
          <div className="sumsubModalWrapper">
            {loading ? <h4>Please wait...</h4> : <h1>Sumsub Verification</h1>}
            {accessToken ? (
              <SumsubWebSdk
                style={{width: "100%"}}
                className="sumsub_modal"
                accessToken={accessToken}
                expirationHandler={accessTokenExpirationHandler}
                // config={config}
                // options={options}
                onMessage={messageHandler}
                onError={errorHandler}
              />
            ) : (
              false
            )}
            <button
              variant="outlined"
              size="medium"
              onClick={sumHandleClose}
              style={{marginTop: "20px"}}
            >
              Close
            </button>
          </div>
        </Card>
      </Box>
    </Modal>
  );
};

export default SumsubModal;
